import {
  Component,
  Input,
  Output,
  SimpleChange,
  ElementRef,
  EventEmitter,
  Inject,
} from "@angular/core";
import {
  VAIconRegistryService,
  closeCircle,
  download,
  infoCircle,
  folder,
  republish,
  questionCircle,
  print as printIcon,
} from "@va/core-library/icons";
import { Subscription } from "rxjs";
import { TPRDataService } from "../tpr-data.service";
import { ResearchGridDataService } from "src/app/research-grid-page/research-grid-data.service";
import { DOCUMENT } from "@angular/common";
import { AppService } from "src/app/app.service";
import { PrintDocResponse } from "src/app/research-page/research-page.model";
import { ResearchPageDataService } from "src/app/research-page/research-page-data.service";
import print from "print-js";
import { NzMessageService } from "ng-zorro-antd/message";

import { TPR_LOG_ACTION_FEATURES, TPR_PAGE } from "src/app/tpr/tpr-constants";
@Component({
  selector: "app-tpr-document-grid",
  templateUrl: "./tpr-document-grid.component.html",
  styleUrls: ["./tpr-document-grid.component.scss"],
})
export class TprDocumentGridComponent {
  @Input() primaryTickerValue: boolean;
  @Input() researchCheckboxValue: boolean;
  @Input() modelCheckboxValue: boolean;
  @Input() filingCheckboxValue: boolean;
  @Input() startDate: string;
  @Input() endDate: string;
  @Input() companyId: number;
  @Input() sourceId: number;
  @Input() ticker: number;
  @Output() hasAccessEvent = new EventEmitter();

  listOfData = [];
  gridHeight = "300px";
  sortBy: string;
  sortOrder = "dsc";
  offset_research = 0;
  offset_models = 0;
  offset_filings = 0;
  page_size = 10;
  isResearch = false;
  isModels = false;
  isFilings = false;
  isPrinting = false;
  access: any = {};
  loading = false;
  latestModelExist = false;
  // subscribers
  tprDocumentGridDetailsSubscriber: Subscription;

  constructor(
    private iconRegistry: VAIconRegistryService,
    private elementRef: ElementRef,
    private dataService: TPRDataService,
    private researchGridDataService: ResearchGridDataService,
    private researchPageDataService: ResearchPageDataService,
    private appService: AppService,
    private message: NzMessageService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {
    this.iconRegistry.registerIcons([
      closeCircle,
      infoCircle,
      folder,
      download,
      printIcon,
      republish,
      questionCircle,
    ]);
  }

  ngOnDestroy() {
    if (this.tprDocumentGridDetailsSubscriber) {
      this.tprDocumentGridDetailsSubscriber.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChange) {
    if (
      (changes["primaryTickerValue"] &&
        changes["primaryTickerValue"].previousValue !==
          changes["primaryTickerValue"].currentValue) ||
      (changes["researchCheckboxValue"] &&
        changes["researchCheckboxValue"].previousValue !==
          changes["researchCheckboxValue"].currentValue) ||
      (changes["modelCheckboxValue"] &&
        changes["modelCheckboxValue"].previousValue !==
          changes["modelCheckboxValue"].currentValue) ||
      (changes["filingCheckboxValue"] &&
        changes["filingCheckboxValue"].previousValue !==
          changes["filingCheckboxValue"].currentValue) ||
      (changes["startDate"] &&
        changes["startDate"].previousValue !==
          changes["startDate"].currentValue) ||
      (changes["endDate"] &&
        changes["endDate"].previousValue !== changes["endDate"].currentValue) ||
      (changes["sourceId"] &&
        changes["sourceId"].previousValue !== changes["sourceId"].currentValue)
    ) {
      this.latestModelExist = false;
      this.refreshCall();
    }
  }

  props = {
    widthConfig: ["144px", "170px", "280px", "110px", "70px", "70px"],
    bordered: true,
    columnsData: [
      [
        {
          header: "Date Published",
          children: 0,
          showSort: true,
          sortKey: "publication_date",
          showFilter: false,
          filterType: "text",
        },
        {
          header: "Analyst",
          children: 0,
          showSort: false,
          sortKey: "analyst", // should be same as field key's value in fields array
          showFilter: false,
          filterType: "text",
        },
        {
          header: "Title",
          children: 0,
          showSort: false,
          sortKey: "title",
          showFilter: false,
          filterType: "text",
        },
        {
          header: "Type",
          children: 0,
          showSort: false,
          sortKey: "type",
          showFilter: false,
          filterType: "text",
        },
        {
          header: "Pages",
          children: 0,
          showSort: false,
          sortKey: "pages",
          showFilter: false,
          filterType: "text",
        },
        {
          header: "Actions",
          children: 0,
          showSort: false,
          sortKey: "actions",
          showFilter: false,
          filterType: "text",
        },
      ],
    ],
    fields: [
      { renderer: "target-pricing-last-change", field: "datePublished" },
      { renderer: "", field: "analyst" },
      { renderer: "link", field: "title" },
      { renderer: "", field: "type" },
      { renderer: "icon-link", field: "pages" },
      { renderer: "multi-icon", field: "actions" },
    ],
  };

  getDocumentAnalystDetails = (item, broker) => {
    const analyst = {
      target: "_blank",
      displayText: item.displayName,
      tooltipText: "",
      url: `/reporting/analyst/`,
      textEllipsis: 22,
      name: item.displayName,
      broker: broker,
      email: item.email,
      nameLink: `/reporting/analyst/`,
      brokerLink: `/reporting/broker/${broker}`,
    };
    return analyst;
  };

  getTitle = (docs) => {
    if (docs.title.toLowerCase() !== "filing") {
      const isModelDoc = docs.type === "Model";
      let link = "";
      const pgCode = docs.pg;
      const publisherName = docs.publisher.broker_shortname;
      let title = "";
      let isLatestModel = false;
      if (isModelDoc && pgCode && publisherName && this.ticker) {
        link = `/mex/${this.ticker}/SAR/${pgCode}/${publisherName}`;
        title = "Go to Analyst Model";
        if (!this.latestModelExist && this.sortOrder === "dsc") {
          this.latestModelExist = true;
          isLatestModel = true;
        }
      } else if (docs.type === "Research") {
        link = `/research_document/${docs.id}/${this.ticker}`;
        title = docs.title;
      }
      return {
        show: true,
        linkText: docs.title,
        url: link,
        target: "new",
        displayText: title,
        ticker: docs.ticker,
        clickCallback: this.handleTitleClick.bind(this),
        clickData: {
          research_document_id: docs.id,
          title: docs.title,
          docType: docs.type,
          daydiff: docs.daydiff,
          publishDate: docs.publish_date
            ? [this.appService.getFormattedDate(docs.publish_date)]
            : undefined,
          changedDate: this.appService.getFormattedDate(new Date()),
          ticker: this.ticker,
          publisherName,
          isLatestModel,
        },
      };
    }
    return {
      target: "",
      url: "",
      displayText: docs.title,
    };
  };

  handleTitleClick(data) {
    if (
      data.docType === "Model" &&
      !data.isLatestModel &&
      data.daydiff !== "-0d"
    ) {
      const postObject = {
        company: data.ticker,
        cut: "SAR",
        source: data.publisherName,
        jsonData: {
          Revisions: {
            type: "row",
            values:
              typeof data.daydiff === "string"
                ? [data.daydiff.toUpperCase()]
                : undefined,
            revision_date_list: data.publishDate,
            changed_date: data.changedDate,
          },
        },
      };
      this.dataService.saveGridpanelshistory(postObject).subscribe();
    }
    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      TPR_LOG_ACTION_FEATURES.companyDocumentTitleClick,
      data,
      "",
      TPR_PAGE,
    );
  }

  getData() {
    const payload = {
      company_id: [this.companyId],
      source: this.sourceId,
      start_date: this.startDate,
      end_date: this.endDate,
      primary_co: this.primaryTickerValue === true ? 1 : -1,
      get_research: this.researchCheckboxValue,
      get_models: this.modelCheckboxValue,
      get_filings: this.filingCheckboxValue,
      offset_research: this.offset_research,
      offset_models: this.offset_models,
      offset_filings: this.offset_filings,
      page_size: this.page_size,
      sort_by: this.sortBy,
      sort_order: this.sortOrder,
    };
    this.tprDocumentGridDetailsSubscriber = this.dataService
      .getTprDocumentGridDetails(payload)
      .subscribe((response) => {
        if (response && response["docs"]) {
          response["docs"].forEach((docs, i) => {
            this.listOfData = [
              ...this.listOfData,
              {
                id: i,
                datePublished: {
                  dateValue: docs.publish_date,
                  dayDiff: docs.daydiff,
                },
                analyst: docs.analysts[0].displayName,
                title: this.getTitle(docs),
                type: docs.type,
                pages: {
                  linkText: docs.page_count,
                  isTextNotLink: true,
                  show: true,
                },
                actions: [
                  {
                    clickCallback: () => {
                      this.onClickDownload(docs);
                    },
                    title: "Download",
                    icon: "download",
                    show: docs.downloadable,
                    className: "test-class-7",
                  },
                  {
                    clickCallback: () => {
                      this.onClickPrint(docs);
                    },
                    clickData: "Print",
                    title: "Print",
                    icon: "print",
                    show: docs.printable,
                    className: "test-class-7",
                  },
                ],
              },
            ];
          });
          (this.offset_research = response["offset_research"]),
            (this.offset_models = response["offset_models"]),
            (this.offset_filings = response["offset_filings"]),
            (this.isResearch = response["get_research"]),
            (this.isModels = response["get_models"]),
            (this.isFilings = response["get_filings"]),
            (this.loading = false);

          this.access = {
            has_filings_access: response["has_filings_access"],
            has_model_access: response["has_model_access"],
            has_research_access: response["has_research_access"],
          };
          this.hasAccessEvent.emit(this.access);
        }
      });
  }
  onPdfLoadEnd(): void {
    this.isPrinting = false;
  }
  showPdfLoadError(): void {
    this.message.error(`Error: Failed to load file. Please try again later.`, {
      nzDuration: 2000,
    });
    this.isPrinting = false;
  }

  onClickPrint(docs) {
    this.isPrinting = true;
    this.researchPageDataService
      .getResearchDocument(Number(docs.id))
      .subscribe((resp: PrintDocResponse) => {
        let printUrl = resp.Data.Url;
        printUrl = decodeURIComponent(printUrl);
        print({
          printable: printUrl,
          type: "pdf",
          onLoadingEnd: this.onPdfLoadEnd.bind(this),
          onError: this.showPdfLoadError.bind(this),
        });
      });

    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      TPR_LOG_ACTION_FEATURES.companyDocumentPrint,
      {
        beginning_state_referrer: "TPR_Documents_Modal",
        document_id: docs.id,
        mime_type: docs.mime_type,
        type: docs.type,
      },
      "",
      TPR_PAGE,
    );
  }

  getDownloadDocumentName = (doc: any) => {
    let docName = "";
    const titleForDocName = doc.title.substring(0, 15);
    const dateForDocName = doc.publication_date.split("T")[0];
    const pageCountForDocName =
      doc.page_count !== null ? `-${doc.page_count} pages` : "";
    docName = `${dateForDocName}-${doc.publisher.broker_name}-${doc.symbols[0].ticker}-${titleForDocName}${pageCountForDocName}`;
    return docName;
  };

  onClickDownload(docs) {
    const isModelDocument = docs.type.toLowerCase() === "model";
    if (docs.type.toLowerCase() === "research") {
      const companyId = docs.company;
      const dataToPass = docs;
      const fileName = this.getDownloadDocumentName(dataToPass);
      const downloadUrl = this.researchGridDataService.getDownloadDocumentURL(
        dataToPass.id,
        companyId,
        fileName,
        docs.publisher.enable_watermark,
      );
      const iFrameId = `research_download_${docs.id}`;
      this.appService.downloadFileWithIFrame(downloadUrl, iFrameId);
    } else if (isModelDocument) {
      const downloadUrl = `/api/model?TransactionId=${docs.id}&source=${docs.publisher.broker_shortname}&company=${docs.company}&pg=${docs.pg}&cut=HOME
    `;
      const iFrameId = `research_model_download_${docs.id} `;
      this.appService.downloadFileWithIFrame(downloadUrl, iFrameId);
    }

    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      isModelDocument
        ? TPR_LOG_ACTION_FEATURES.companyModelDocumentDownload
        : TPR_LOG_ACTION_FEATURES.companyResearchDocumentDownload,
      {
        beginning_state_referrer: "TPR_Documents_Modal",
        document_id: docs.id,
        mime_type: isModelDocument ? "xlsx" : docs.mime_type,
        type: docs.type,
      },
      "",
      TPR_PAGE,
    );
  }

  onScroll() {
    if (
      this.offset_filings !== 0 ||
      this.offset_models !== 0 ||
      this.offset_research !== 0
    ) {
      this.getData();
    }
  }

  sort(sort) {
    this.sortBy = sort[0].key;
    this.sortOrder = sort[0].value === "ascend" ? "asc" : "dsc";
    this.refreshCall();
  }

  refreshCall() {
    this.offset_research = 0;
    this.offset_models = 0;
    this.offset_filings = 0;
    this.listOfData = [];
    const tableBodyElement = this.elementRef.nativeElement.querySelector(
      ".documentTable .ant-table-body",
    );
    if (tableBodyElement) {
      tableBodyElement.scrollTop = 0;
    }
    this.loading = true;
    this.onScroll();
    this.getData();
  }
}
